// StaticMapCard.jsx
import React, { useMemo } from 'react';
import { Paper, Box } from '@mui/material';

export default function StaticMapCard({
  coords, // { lat, lng }
  zoom = 18,
  apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  width = 730, // can be number (px) or string (e.g. '92vw')
  height = 267, // ignored when width is a string (responsive mode)
  borderRadius = 24,
  overlay = null, // anything you want to render on top (e.g., the bubble)
}) {
  const url = useMemo(() => {
    if (!coords) return null;

    // Request a crisp image (scale=2). Display size is controlled by container CSS.
    const reqW = 640;
    const reqH = 234;
    const scale = 2;
    const center = `${coords.lat},${coords.lng}`;

    const params = new URLSearchParams({
      key: apiKey || '',
      center,
      zoom: String(zoom),
      size: `${reqW}x${reqH}`,
      scale: String(scale),
      maptype: 'satellite',
      // no markers → no pin
    });

    return `https://maps.googleapis.com/maps/api/staticmap?${params.toString()}`;
  }, [coords, zoom, apiKey]);

  if (!coords) return null;

  const isResponsive = typeof width === 'string';

  return (
    <Paper
      elevation={0}
      sx={{
        width,
        ...(isResponsive ? { height } : { height }),
        borderRadius,
        overflow: 'hidden',
        boxShadow: `0px 1px 2px 0px #A2ACB133, 0px 12px 24px -4px #162F3B1F`,
        position: 'relative',
        opacity: 1,
      }}
    >
      <img
        src={url || ''}
        alt="Selected location preview"
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
          userSelect: 'none',
          pointerEvents: 'none',
        }}
      />

      {/* Optional subtle top → transparent gradient to help text read on light tiles (keeps attribution visible) */}
      <Box
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(to bottom, rgba(255,255,255,0.08), rgba(255,255,255,0))',
        }}
      />

      {/* Overlay (bubble, etc.) */}
      {overlay}
    </Paper>
  );
}
